<template>
  <div class="solution3">
    <!--1:banner-->
    <div class="block s1_banner s3_banner">
      <div :class="{content:true}">
        <div class="item1">
          <div class="box">
            <p :class="{title:true,animated:true,fadeInUp:isUp,delay1s:true}">一物一码品牌防伪</p>
            <div :class="{detail:true,animated:true,fadeInUp:isUp,delay2s:true}">
              一扫辨知真伪，科技缔造安全，RFID+物联网，全程数字定制化解决方案，提升企业精细化管理。
            </div>
            <a :class="{btn:true,animated:true,fadeInUp:isUp,delay3s:true}" @click="goU('startApply')">联系我们</a>
          </div>
        </div>
      </div>
    </div>
    <!--方案体系-->
    <div class="part1">
      <div class="bg">
        <p class="title">方案体系</p>
        <div class="system1" :class="{gw_fadeLeft:isUp,animated:true,delay4s:true}">关键数据采集</div>
        <div class="system2" :class="{gw_fadeLeft:isUp,animated:true,delay4s:true}">专属品牌防伪方案</div>
        <div class="system3" :class="{gw_fadeLeft:isUp,animated:true,delay4s:true}">数码生成及标签印刷</div>
        <div class="system4" :class="{gw_fadeRight:isUp,animated:true,delay4s:true}">军用级防伪加密</div>
        <div class="system5" :class="{gw_fadeRight:isUp,animated:true,delay4s:true}">品牌防伪运营</div>
        <div class="system6" :class="{gw_fadeRight:isUp,animated:true,delay4s:true}">防伪标签设计</div>
        <div class="system">因科技更安全</div>
      </div>
    </div>
    <!--方案价值-->
    <div class="part2">
      <div class="mainContainer">
        <p class="title">方案价值</p>
        <div class="box_wrap flex_between">
          <div class="box">
            <div class="icon"><i></i></div>
            <p>提升品牌</p>
            <div>提高产品档次，不断提升品牌信誉度</div>
          </div>
          <div class="box">
            <div class="icon icon2"><i></i></div>
            <p>降低成本</p>
            <div>降低广告成本，产品推广营销一体化</div>
          </div>
          <div class="box">
            <div class="icon icon3"><i></i></div>
            <p>降低风险</p>
            <div>售前防伪、售后防伪，降低运营风险</div>
          </div>
          <div class="box">
            <div class="icon icon4"><i></i></div>
            <p>质量可控</p>
            <div>一物一码实现真伪可辨别，质量可控</div>
          </div>
        </div>
      </div>
    </div>
    <!--客户案例-->
    <div class="part3">
      <div class="mainContainer">
        <p class="title">客户案例</p>
        <div class="flex_between">
          <div class="item_left flex_center"><i></i></div>
          <div class="item_right">
            <p>骗保一直是让保险业头疼的问题，在现今这个以诚信编织的社会里，从道德层面上约束人们的行为很重要，但有效的利用科技手段防范和杜绝顽固分子的骗保行为也是行业急需解决的问题。</p>
            <p>日前，杭州牛盾网络技术有限公司与都邦保险正式签约，联合打造业内首创的“物联网+保险”安全保险模式，为保险业内有溯源需求的险种量身打造了一款物联网辨识标签，并提供了全方位的解决方案，以快递工具险种为例。</p>
          </div>
        </div>
      </div>
    </div>
    <!--方案优势-->
    <div class="part4">
      <div class="mainContainer flex_between">
        <div class="left">
          <p>解决方案</p>
          <div><i></i><span>给三轮电动车一个“保险身份”</span></div>
          <div><i></i><span>技术手段治理物流公司乱报现象”</span></div>
          <div><i></i><span>“物联网+保险”让续保更便利</span></div>
          <div><i></i><span>数据可溯源，大数据助力保险数字化</span></div>
        </div>
        <div class="mid">
          <p>方案优势</p>
          <div><i></i><span>规避骗保现象，降低赔付率，减少理赔损失。</span></div>
          <div><i></i><span>手机扫描，信息查询更便捷、后台管理更高效。</span></div>
          <div><i></i><span>一车一码，编码、二维码、射频标识三码合一。</span></div>
          <div><i></i><span>软件系统安全防护能力强，保单数据安全可靠。</span></div>
        </div>
        <div class="right">
          <i></i>
        </div>
      </div>
    </div>
    <!--footer-->
    <div class="gw_homefooterBox">
      <footerBar></footerBar>
    </div>
  </div>
</template>

<script>
  import footerBar from '../../components/footerbar'
  export default {
    name: "solution3",
    data(){
      return{
        isUp:false
      }
    },
    components:{
      footerBar
    },
    mounted(){
      this.isUp = true;
    },
    methods:{
      goU(url) {
        this.$router.push({name: url,params:{product:2,title:'预约演示'}});
      },
    }
  }
</script>

<style scoped lang="scss">
  .solution3{
    .s3_banner{
      .content{
        background:url("../../assets/img/solution3/banner.jpg") no-repeat center;
      }
    }
    .title{
      font-family: 'pingfangBold';
      font-size: 24px;
      color: #000000;
    }
    /*方案体系*/
    .part1{
      height:648px;
      .bg{
        width:1205px;
        height:648px;
        background:url("../../assets/img/solution3/sl_1.png") no-repeat center;
        background-size:100% 100%;
        margin:0 auto;
        position:relative;
        .title{
          padding-top:70px;
        }
        div{
          font-size: 16px;
          color: #4A4A4A;
          letter-spacing: 1px;
          position:absolute;
        }
        .system1{
          top:173px;
          left:320px;
        }
        .system2{
          top:338px;
          left:210px;
        }
        .system3{
          top:502px;
          left:270px;
        }
        .system4{
          top:173px;
          right:295px;
        }
        .system5{
          top:338px;
          right:245px;
        }
        .system6{
          top:502px;
          right:310px;
        }
        .system{
          top:378px;
          left:550px;
        }
      }
    }
    /*方案价值*/
    .part2{
      background: #FAFAFA;
      padding-top:35px;
      padding-bottom:48px;
      .title{
        margin-bottom:35px;
      }
      .box_wrap{
        .box{
          width:270px;
          height:169px;
          background: #FFFFFF;
          border: 1px solid #D8D8D8;
          box-sizing: border-box;
          padding:30px 22px 26px;
          .icon{
            i{
              display: inline-block;
              width:47px;
              height:44px;
              background:url("../../assets/img/solution3/box1.png") no-repeat center;
              background-size:100% 100%;
            }
          }
          .icon2{
            i{
              width:40px;
              height:43px;
              background:url("../../assets/img/solution3/box2.png") no-repeat center;
              background-size:100% 100%;
            }
          }
          .icon3{
            i{
              width:36px;
              height:46px;
              background:url("../../assets/img/solution3/box3.png") no-repeat center;
              background-size:100% 100%;
            }
          }
          .icon4{
            i{
              width:42px;
              height:46px;
              background:url("../../assets/img/solution3/box4.png") no-repeat center;
              background-size:100% 100%;
            }
          }
          p{
            font-size: 16px;
            color: #000;
            margin:10px 0;
          }
          div{
            font-size: 14px;
            color: #4A4A4A;
          }
        }
      }
    }
    /*客户案例*/
    .part3{
      background:#fff;
      padding:50px 0 70px;
      .title{
        margin-bottom: 30px;
      }
      .item_left{
        border: 1px solid #E9E9E9;
        border-radius: 3px;
        width:257px;
        height:116px;
        i{
          display: inline-block;
          width:167px;
          height:40px;
          background:url("../../assets/img/solution3/case_icon.png") no-repeat center;
          background-size:100% 100%;
        }
      }
      .item_right{
        text-align: left;
        width:870px;
        p{
          font-size: 16px;
          color: #4A4A4A;
          &:first-child{
            margin-bottom:20px;
          }
        }
      }
    }
    /*方案优势*/
    .part4{
      background: #FAFAFA;
      padding:35px 0 70px;
      .left,.mid{
        text-align: left;
        p{
          font-size: 20px;
          color: #000000;
          margin-bottom:30px;
        }
        div{
          font-size: 16px;
          color: #333333;
          margin-bottom: 20px;
          &:last-child{
            margin-bottom:0;
          }
        }
      }
      .left{
        div{
          i{
            display: inline-block;
            width:18px;
            height:18px;
            background:url("../../assets/img/solution3/solution_icon1.png") no-repeat center;
            background-size:100% 100%;
            vertical-align: middle;
            margin-right:17px;
          }
        }
      }
      .mid{
        div{
          i{
            display: inline-block;
            width:20px;
            height:20px;
            background:url("../../assets/img/solution3/solution_icon2.png") no-repeat center;
            background-size:100% 100%;
            vertical-align: middle;
            margin-right:17px;
          }
        }
      }
      .right{
        position:relative;
        top:20px;
        i{
          display: inline-block;
          width:290px;
          height:187px;
          background:url("../../assets/img/solution3/label.png") no-repeat center;
          background-size:100% 100%;
        }
      }
    }
  }
  .gw_homefooterBox{
    height:160px;
  }
</style>



// WEBPACK FOOTER //
// src/views/solution/solution3.vue